import { IGroupWithIds } from "@app/main/components/resourceManagement/groups/_models/IGroupWithIds";
import { BroadcastEvent } from "@enums/BroadcastEvent";
import { ResourceType } from "@enums/ResourceType";
import { IGroupFilter } from "@interfaces/filters/IGroupFilter";
import { IRunBlockRootScope } from "@interfaces/IRunBlockRootScope";
import { GroupService } from "@services/group.service.ajs";
import { TranslationService } from "@services/translation.service";
import * as angular from "angular";
import { IFilterBar, IFilterBarFilter } from "../newResourceFilterBar.component";
import "./groupResourceFilter.scss";

interface IComponentBindings {
    selectedGroup: IGroupWithIds;
    groupId: number;
    placeholder: string;
}

class ComponentController implements angular.IComponentController, IComponentBindings, IFilterBarFilter<IGroupFilter> {

    parent: IFilterBar;
    show = false;
    isDirty = false;

    filterName = "Group";
    filterLabel: string;
    filterTitle: string;
    filterIcon: string;
    showClearFilterButton = true;

    placeholder: string;

    groups: IGroupWithIds[];
    selectedGroup: IGroupWithIds;
    selectedResourceType: ResourceType;

    groupId: number;

    previousFilter: IGroupFilter;

    onChange: (args: { filter: IGroupFilter }) => void;

    static $inject = ["$rootScope", "$element", "groupService", "translationService", "$scope"];

    constructor(
        private readonly $rootScope: IRunBlockRootScope,
        public readonly $element: HTMLElement,
        private readonly groupService: GroupService,
        private readonly translationService: TranslationService,
        private readonly $scope: angular.IScope) {
    }

    $onInit() {
        this.parent.registerFilter(this);
    }

    $onDestroy() {
        this.show = false;
    }

    $onChanges(onChangesObj: angular.IOnChangesObject) {
        this.updateFilterLabel();

        if (onChangesObj['groupId'] && this.groupId) {

            this.selectedGroup = null;
            this.getGroups();
        }
    }

    toggleFilter(show: boolean) {
        this.show = show;

        if (this.show) {
            this.getGroups();
        }
    }

    groupClicked(group: IGroupWithIds) {
        this.groupId = null;

        if (this.selectedGroup && group.Id === this.selectedGroup.Id) {
            this.selectedGroup = null;
        }
        else {
            this.selectedGroup = group;
        }

        this.updateFilterLabel();

        this.createFilterObject();

        this.$rootScope.$broadcast(BroadcastEvent.closeResourceFilterBar);
    }

    clearFilter() {
        this.selectedGroup = null;
        this.groupId = null;

        this.updateFilterLabel();
    }

    createFilterObject(): IGroupFilter {
        return {
            resourceType: this.selectedResourceType,
            group: this.selectedGroup
        };
    }

    // ------------------

    private getGroups() {
        this.groupService.getGroupsWithFullMappings().then(groups => {
            this.groups = groups;

        }).finally(() => {
            this.updateFilterLabel();
            this.$scope.$applyAsync();
        });
    }

    private updateFilterLabel() {
        this.filterLabel = this.placeholder ? this.translationService.t('filters.groupResourceFilter.resourceGroup', this.placeholder) : this.translationService.t('Common.Groups');

        //this.filterIcon = "grid_on"; // good for table filter?
        this.filterIcon = "topic";

        if (this.groups && this.groupId) {
            this.selectedGroup = this.groups.find(group => group.Id === this.groupId);
        }

        if (this.selectedGroup) {
            this.filterLabel = this.selectedGroup.Name;
        }

        this.isDirty = !!this.selectedGroup;
    }
}

export class GroupResourceFilterComponent implements angular.IComponentOptions {
    bindings: any;
    controller: any;
    require: { [index: string]: string; };
    template: string;

    constructor() {
        this.bindings = {
            selectedGroup: "<group",
            groupId: "<?",
            placeholder: "<?",

            onChange: "&"
        };

        this.require = {
            parent: "^newResourceFilterBar"
        };

        this.controller = ComponentController;
        this.template = require("./groupResourceFilter.html");
    }
}
